import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/splashPage/avatars/spencer.webp'

export const SpencerImage: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'Spencer'} />
)
